import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mb-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_text_area_form = _resolveComponent("text-area-form");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_radio_button_form = _resolveComponent("radio-button-form");
    const _component_el_radio = _resolveComponent("el-radio");
    const _component_el_table = _resolveComponent("el-table");
    return (_openBlock(), _createBlock(_component_el_table, {
        data: _ctx.competencyUnitRow,
        "scrollbar-always-on": true,
        "default-expand-all": ""
    }, {
        default: _withCtx(() => {
            var _a;
            return [
                _createVNode(_component_el_table_column, { type: "expand" }, {
                    default: _withCtx((scope) => {
                        var _a;
                        return [
                            _createVNode(_component_text_area_form, {
                                label: "Benchmark (SOP/Spesifikasi produk industri)",
                                modelValue: scope.row.benchmark,
                                "onUpdate:modelValue": ($event) => ((scope.row.benchmark) = $event),
                                disabled: "",
                                autosize: { minRows: 3 }
                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((_a = _ctx.competencyUnit.customAnswerFields) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerType.id === _ctx.answerTypeId)) || [], (item, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (item.answerField.type === 'textarea')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (_ctx.isAssessment)
                                                ? (_openBlock(), _createBlock(_component_text_area_form, {
                                                    key: 0,
                                                    label: item.label,
                                                    modelValue: _ctx.modelStatementFields[_ctx.foundIndex(scope.row, item.answerField.id).statementFields].statementDetailFields[scope.row.detailIndex]
                                                        .statementDetailAnswerFields[_ctx.foundIndex(scope.row, item.answerField.id)
                                                        .statementDetailAnswerFields].value,
                                                    "onUpdate:modelValue": ($event) => ((_ctx.modelStatementFields[_ctx.foundIndex(scope.row, item.answerField.id).statementFields].statementDetailFields[scope.row.detailIndex]
                                                        .statementDetailAnswerFields[_ctx.foundIndex(scope.row, item.answerField.id)
                                                        .statementDetailAnswerFields].value) = $event),
                                                    disabled: _ctx.disabled,
                                                    autosize: { minRows: 3 }
                                                }, null, 8 /* PROPS */, ["label", "modelValue", "onUpdate:modelValue", "disabled"]))
                                                : (_openBlock(), _createBlock(_component_text_area_form, {
                                                    key: 1,
                                                    label: item.label,
                                                    disabled: _ctx.disabled,
                                                    autosize: { minRows: 3 }
                                                }, null, 8 /* PROPS */, ["label", "disabled"]))
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ];
                    }),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_el_table_column, {
                    label: "Pertanyaan",
                    width: "auto",
                    "min-width": "400"
                }, {
                    default: _withCtx((scope) => [
                        (scope.row.detailIndex === 0)
                            ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(scope.row.description), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("ul", null, [
                            _createElementVNode("li", null, _toDisplayString(scope.row.details[scope.row.detailIndex].description), 1 /* TEXT */)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((_a = _ctx.competencyUnit.customAnswerFields) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerType.id === _ctx.answerTypeId)) || [], (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (item.answerField.type === 'radio')
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                label: item.label,
                                align: "center"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, optionIndex) => {
                                        return (_openBlock(), _createBlock(_component_el_table_column, {
                                            key: optionIndex,
                                            label: option.label,
                                            align: "center",
                                            width: "130"
                                        }, {
                                            default: _withCtx((scope) => [
                                                (_ctx.isAssessment)
                                                    ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                        key: 0,
                                                        options: [{ label: null, value: option.value }],
                                                        modelValue: _ctx.modelStatementFields[_ctx.foundIndex(scope.row, item.answerField.id).statementFields].statementDetailFields[scope.row.detailIndex]
                                                            .statementDetailAnswerFields[_ctx.foundIndex(scope.row, item.answerField.id)
                                                            .statementDetailAnswerFields].value,
                                                        "onUpdate:modelValue": ($event) => ((_ctx.modelStatementFields[_ctx.foundIndex(scope.row, item.answerField.id).statementFields].statementDetailFields[scope.row.detailIndex]
                                                            .statementDetailAnswerFields[_ctx.foundIndex(scope.row, item.answerField.id)
                                                            .statementDetailAnswerFields].value) = $event),
                                                        borderless: "",
                                                        disabled: _ctx.disabled,
                                                        center: "",
                                                        rules: [_ctx.validationRequired()],
                                                        prop: `fields.${_ctx.order}.statementFields.${_ctx.foundIndex(scope.row, item.answerField.id).statementFields}.statementDetailFields.${scope.row.detailIndex}.statementDetailAnswerFields.${_ctx.foundIndex(scope.row, item.answerField.id)
                                                            .statementDetailAnswerFields}.value`
                                                    }, null, 8 /* PROPS */, ["options", "modelValue", "onUpdate:modelValue", "disabled", "rules", "prop"]))
                                                    : (_openBlock(), _createBlock(_component_el_radio, {
                                                        key: 1,
                                                        label: option.value,
                                                        disabled: _ctx.disabled
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(null))
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "disabled"]))
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                            : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */));
                }), 128 /* KEYED_FRAGMENT */))
            ];
        }),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data"]));
}
